import { ChevronUp, ShieldCheck, Database, Target, HardDrive,  ClipboardCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  const sections = [
    {
      icon: <ClipboardCheck className="w-6 h-6" />,
      title: "1. Fecha de entrada en vigor",
      content: "Esta política entra en vigor el 29 de mayo de 2024."
    },
    {
      icon: <ShieldCheck className="w-6 h-6" />,
      title: "2. Entidad Receptora de la Información",
      content: "SAHEZ MEDIC, E.I.R.L, constituida en República Dominicana con domicilio en Ensanche Libertad, Santiago."
    },
    {
      icon: <Database className="w-6 h-6" />,
      title: "3. Recopilación de Datos",
      content: (
        <>
          Recopilamos datos mediante:
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Información de cuenta de usuario</li>
            <li>Datos de geolocalización</li>
            <li>Información del dispositivo y conexión</li>
            <li>Tecnologías como cookies y balizas web</li>
          </ul>
        </>
      )
    },
    {
      icon: <Target className="w-6 h-6" />,
      title: "4. Uso de los Datos",
      content: (
        <>
          Finalidades principales:
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Mejorar experiencia de usuario</li>
            <li>Proveer acceso a servicios</li>
            <li>Comunicaciones de marketing</li>
          </ul>
        </>
      )
    },
    {
      icon: <HardDrive className="w-6 h-6" />,
      title: "5. Almacenamiento de Datos",
      content: "Conservamos datos según Ley No. 172-13 de RD. Eliminación segura cuando ya no sean necesarios."
    },
    {
      icon: <ClipboardCheck className="w-6 h-6" />,
      title: "6. Aceptación y Cambios",
      content: "El uso del sitio implica aceptación. Actualizaciones publicadas en esta página."
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <div className="min-h-screen bg-main-bg">
      {/* Encabezado */}
      <header className="bg-gradient-to-r from-primary to-dark text-main-bg py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 
            
            className="text-4xl md:text-5xl font-poppins font-bold mb-4"
          >
            Política de Privacidad
          </h1>
          <p className="text-lg font-montserrat max-w-3xl mx-auto">
            Protección de datos según la Ley No. 172-13 de República Dominicana
          </p>
        </div>
      </header>

      {/* Contenido principal */}
      <main className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          {/* Índice lateral (oculto en móvil) */}
          <div 
            className="hidden lg:block lg:col-span-1 sticky top-20 h-fit"
           
          >
            <div className="bg-section-bg p-6 rounded-xl shadow-lg">
              <h2 className="text-xl font-poppins font-semibold text-dark mb-4">Índice</h2>
              <ul className="space-y-3 font-montserrat">
                {sections.map((section, index) => (
                  <li key={index}>
                    <a 
                      href={`#section-${index + 1}`} 
                      className="text-dark hover:text-primary transition-colors flex items-center gap-2"
                    >
                      <ChevronUp className="w-4 h-4 rotate-45" />
                      {section.title.split(' ').slice(1).join(' ')}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Secciones */}
          <div 
            className="lg:col-span-3 space-y-12"
           
          >
            {sections.map((section, index) => (
              <section 
                key={index}
                id={`section-${index + 1}`}
                className="bg-section-bg p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="bg-primary p-3 rounded-lg text-main-bg">
                    {section.icon}
                  </div>
                  <h2 className="text-2xl font-poppins font-semibold text-dark">
                    {section.title}
                  </h2>
                </div>
                <div className="text-gray-700 font-montserrat leading-relaxed">
                  {section.content}
                </div>
              </section>
            ))}
          </div>
        </div>

        {/* Nota legal */}
        <div 
          className="mt-16 p-8 border-2 border-primary rounded-xl bg-main-bg"
         
        >
          <div className="max-w-4xl mx-auto text-center">
            <ShieldCheck className="w-12 h-12 text-primary mx-auto mb-4" />
            <h3 className="text-2xl font-poppins font-semibold text-dark mb-4">
              Ejercicio de Derechos ARCO
            </h3>
            <p className="font-montserrat text-gray-600 mb-6">
              Usted puede ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición contactando a nuestro Delegado de Protección de Datos.
            </p>
            <Link 
              to="/contact" 
              className="inline-block bg-primary text-main-bg px-8 py-3 rounded-lg font-poppins hover:bg-dark transition-colors"
            >
              Ejercer Mis Derechos
            </Link>
          </div>
        </div>

        {/* Botón flotante */}
        <button type='button' title='scroll to top'
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-8 right-8 bg-dark text-main-bg p-3 rounded-full shadow-xl hover:bg-primary transition-colors"
          
        >
          <ChevronUp className="w-6 h-6" />
        </button>
      </main>
    </div>
  );
};

export default PrivacyPage;